/**
 * <Float />
 *
 * @parent anybody
 * @children
 * @stateful
 */
import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames'
import Transition from 'components/UI/Transition';
import './Float.scss';
import keydown, { ALL_KEYS } from 'react-keydown';

class Float extends React.Component {
  static propTypes = {
    // target
    // show
    // floatWidth
    // floatHeight
    // container
    // closeOnBlur
  }

  constructor(props) {
    super(props);

    this.computeFloatXY = this.computeFloatXY.bind(this);
    this.closeFloat = this.closeFloat.bind(this);
    this.listenToKeys = this.listenToKeys.bind(this);
    this.onBlur = this.onBlur.bind(this);

    this.state = {
      show: props.show,
      target: props.target,
    }
  }

  listenToKeys(e) {
    if (e.keyCode === 27) {
      this.closeFloat();
    }
  }

  componentWillReceiveProps(opts) {
    const { show, target, container, floatWidth, floatHeight } = opts;

    if (this.state.show !== true && show == true) {
      this.setState({
        show,
      }, ()=>{
        setTimeout(() => {
          ReactDOM.findDOMNode(this.floatRef).focus();
        }, 10);
      });
    }
    if (this.state.show === true && show == false) {
      this.closeFloat();
    }
  }

  computeFloatXY(container, target, floatWidth, floatHeight) {
    const containerDim = container.getBoundingClientRect();
    const targetDim = target.getBoundingClientRect();

    const rightCorner = targetDim.x - containerDim.left + container.scrollLeft + targetDim.width;
    const topCorner = targetDim.y - containerDim.top + container.scrollTop;

    let leftOffset = 0;
    let bottomOffset = 0;
    let directionX = 'right';
    let directionY = 'down';
    let floatX = 0;
    let floatY = 0;
    if (rightCorner + floatWidth > containerDim.width) {
      leftOffset = (targetDim.width + floatWidth) * -1;
      directionX = 'left';
    }

    if (topCorner + floatHeight > containerDim.height) {
      bottomOffset = (floatHeight - targetDim.height) * -1;
      directionY = 'up';
    }
    floatX = rightCorner + leftOffset;
    floatY = topCorner + bottomOffset;
    if(targetDim.width + floatWidth > containerDim.width) {
      floatX = targetDim.x - containerDim.left + container.scrollLeft;
      floatY = targetDim.y - containerDim.top + container.scrollTop;
    }
    return {
      floatX,
      floatY,
      directionX,
      directionY,
    }
  }

  closeFloat() {
    let {
      onCloseFloat,
    } = this.props;

    this.setState({
      container: null,
      show: false,
      target: null,
      floatX: null,
      floatY: null,
      floatWidth: 'auto',
      floatHeight: 'auto',
      directionX: null,
      directionY: null,
    }, ()=>{
      if (typeof onCloseFloat == 'function') {
        onCloseFloat();
      } 
    });
    
  }

  componentDidUpdate() {
    const {
      container = document.body, 
      target, 
      floatWidth, 
      floatHeight, 
      show,
    } = this.props;
    if (this.floatRef && target && this.state.target != target) {
      const { 
        height,
        width,
      } = this.floatRef.getBoundingClientRect();

      const usedHeight = floatHeight || height;
      const usedWidth = floatWidth || width;

      const {
        floatX,
        floatY,
        directionX,
        directionY,
      } = this.computeFloatXY(container, target, usedWidth, usedHeight);

      this.setState({
        container,
        showComplete: show,
        target,
        floatX,
        floatY,
        floatWidth: usedWidth,
        floatHeight: usedHeight,
        directionX,
        directionY,
      });

    }

  }

  onBlur(e) {
    if (this.props.closeOnBlur === true) {
      return;
    }

    const currentTarget = e.currentTarget;

    //
    // We don't want to close it when the blur is called by
    // an element within the target.
    //
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        this.closeFloat();
      }
    }, 1);
  }

  render() {
    const {
      showComplete,
      floatX,
      floatY,
      directionX,
      show,
    } = this.state;

    const {
      floatHeight,
      floatWidth,
    } = this.props;

    // if (!show) {
    //  this.floatRef = null;
    //  return (<span />);
    // }
    

    const style = { 
      top: floatY, 
      left: floatX, 
      width: floatWidth, 
      height: floatHeight, 
      display: show ? 'block': 'none',
      opacity: showComplete ? 1 : 0,
    }

    return (
      <Transition type={'slide-' + directionX}>
        <div
          className='float-modal'
          style={style}
          ref={(f)=>{this.floatRef = f; }}
          onBlur={this.onBlur}
          tabIndex='0'
          onKeyDown={this.listenToKeys}
        >
          <div className='float-content'>
            {this.props.children}
          </div>
        </div>
      </Transition>
    )
  }
}

export default Float;



// WEBPACK FOOTER //
// ./src/components/UI/Float/index.js